import type { SignInput, SignOutput } from './index'

export type SignOutputFromInput = {
  input: SignInput,
  output: SignOutput
};